import HistorySection from "./HistorySection";
import { useMedicalHistorySection } from "../hooks/use-medical-history-section";
import {
  MEDICAL_HISTORY_LABELS,
  MEDICAL_HISTORY_NAME_LABEL,
} from "../readmission-f2f-constant";

export interface MedicalHistorySectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  freeNoteValue?: string;
  onFreeNoteChange?: (value: string) => void;
}

const MedicalHistorySection = ({
  title,
  expanded,
  onToggle,
  freeNoteValue,
  onFreeNoteChange,
}: MedicalHistorySectionProps) => {
  const section = useMedicalHistorySection();

  return (
    <HistorySection
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      section={section}
      nameLabel={MEDICAL_HISTORY_NAME_LABEL}
      labels={MEDICAL_HISTORY_LABELS}
      freeNoteValue={freeNoteValue}
      onFreeNoteChange={onFreeNoteChange}
    />
  );
};

export default MedicalHistorySection;
